import { IEquityEntry, IFreeTableEntry, IManualAccount } from '@modeso/types__aumico-lib-annualreport-be';
import { IFliTotalRow } from '../../interfaces/IFliTotalRow.interface';
export interface ITableWithForm {
    formValue: IFreeTableEntry[] | IEquityEntry[] | IManualAccount[];
    totalRowValue: IFreeTableEntry | IEquityEntry | IFliTotalRow;
    headers?: StringifyKeys<
        IEquityEntry,
        'text' | 'currentValue1' | 'currentValue2' | 'previousValue1' | 'previousValue2'
    >;
    footnote?: string;
}

export type StringifyKeys<T, K extends keyof T> = {
    [P in keyof T]: P extends K ? string : T[P];
};
